export const CHANGE_USER_INFO_TYPE = {
  email: 'email',
  emailVerify: 'emailVerify',
  phone: 'phone',
  phoneVerify: 'phoneVerify',
  password: 'password',
  pin: 'pin'
}
